module.exports = __webpack_public_path__ + "img/bankcode2.3c5bf6bc.png";